import { message } from 'antd';
import dayjs from 'dayjs';
import { ISubModelInputs } from 'pages/Createpart/Createpart';
import { sortBy, userType } from 'types';

/**
 * @description You can use other date lib of your choice.
 * - important thing is to have an abstraction over it,
 *  we shouldn't pollute all the places in the app by
 *  directly importing the date lib like dayjs/moment.
 *  we should create wrapper function to the date/time
 *  jobs. This helps us replace the date lib if needed.
 *  and also this creates single-source-of-truth
 */

const dateFormat: string = 'dddd, MMMM D';
const timeFormat: string = 'h:mm a';

export const getDisplayDateTime = () => {
  const todaysDate = dayjs();
  const time = todaysDate.format(timeFormat);
  const date = todaysDate.format(dateFormat);
  return {
    date,
    time
  };
};

export enum toastTypeEnum {
  success = 'success',
  info = 'info',
  error = 'error'
}

export const toast = (
  type: toastTypeEnum,
  content: string,
  duration = 3,
  onClose?: ReturnType<typeof message.info>
) => {
  if (typeof content !== 'string') {
    return;
  }
  switch (type) {
    case toastTypeEnum.success:
      message.success(content, duration, onClose);
      break;
    case toastTypeEnum.info:
      message.info(content, duration, onClose);
      break;
    case toastTypeEnum.error:
      message.error(content, duration, onClose);
      break;
    default:
      break;
  }
};

export const capitalize = (name: string): string => {
  return `${name[0].toUpperCase()}${name.substring(1)}`;
};

export const MESSAGES = {
  partAddSuccess: 'Part Added',
  passChangeSuccess: 'Password Changed',
  sendMailSuccess: 'Email Sent Successfully',
  brandAddSuccess: 'Brand Added',
  brandEditedSuccess: 'Brand Changed',
  brandDeletedSuccess: 'Brand Deleted'
};
export const isUrlSvg = (text: string): boolean => {
  return text.substring(text.lastIndexOf('.')) === '.svg';
};

export const sortOrderType = (order: string): sortBy => {
  type Ist = {
    [key: string]: sortBy;
  };
  const st: Ist = {
    descend: 'desc',
    ascend: 'asc'
  };
  return st[order] ? st[order] : null;
};

export const allowedType = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/svg+xml'
];
export const allowedTypePart = ['image/svg+xml'];

export const isSubModelsValid = (
  subModelInputs: ISubModelInputs[],
  showToast = false
): boolean => {
  const notValid = subModelInputs.some(item => !item.subModel || !item.file);
  if (showToast && notValid) {
    toast(toastTypeEnum.error, 'Fill Added Submodels');
  }
  return !notValid;
};

export const getCreateUserTypes = (userType?: userType): userType[] => {
  if (userType === 'admin' || userType === 'super admin') {
    return ['credit', 'distributor', 'employee', 'subscription'];
  } else if (userType === 'employee') {
    return ['distributor', 'credit', 'subscription'];
  } else if (userType === 'distributor') {
    return ['credit'];
  } else {
    return [];
  }
};

export const allowedUserType = ({
  userType
}: {
  userType: userType;
}): boolean => ["super admin", "admin", "distributor", "employee"].includes(userType);

export const patternType = [
  'exterior',
  'interior',
  'phones',
  'Motorcycles',
  'Dealer Packages'
];
